import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import getPath from 'lodash/get';
import head from 'lodash/head';
import styled from 'styled-components';
import Footer from '../../components/footer';
import { SoundwiseHeader } from '../../components/soundwise_header';
import { FullContentWrapper, FullContentSection, FlexiRow, BaseButton } from '../../styles/styled';
import { getLandingPageUrl } from '../../helpers/soundcasts';
import { authManager } from '../../helpers/managers';
import {
  userSession,
  verifyUserSession,
  isUserSessionHasFacebookAuth,
} from '../../helpers/userSession';
import Colors from '../../styles/colors';
import Loading from '../../components/Loading';
import { LoadingWrapper } from '../../styles/styled';
const { polishImageUrl } = require('../../../server/scripts/utils')();

const isValidSubscription = soundcast => {
  const {current_period_end = 0, subscribed = false, subscription_ended = false } = soundcast || {};
  // return subscribed && !subscription_ended;
  return subscribed
    && (current_period_end > 0 ? moment.unix(current_period_end).isAfter(moment()): !subscription_ended);
};

class MySoundcasts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      userSoundcasts: [],
      userBundles: {},
    };

    this.handleSubscription = this.handleSubscription.bind(this);
    this.handleSoundcastAccess = this.handleSoundcastAccess.bind(this);
  }

  componentDidMount() {
    this.loadUserSoundcasts();
  }

  componentWillReceiveProps(nextProps) {
    const oldUserId = getPath(this.props, 'userInfo.id', null);
    const newUserId = getPath(nextProps, 'userInfo.id', null);
    const userIdUpdated = !isEqual(oldUserId, newUserId);

    if (userSession.ready && userIdUpdated) {
      this.loadUserSoundcasts(nextProps);
    }
  }

  async loadUserSoundcasts(props = {}) {
    props = !isEmpty(props) ? props : this.props;

    try {
      await verifyUserSession();
    } catch (e) {
      await new Promise(resolve => setTimeout(resolve, 2000));
      return props && props.history && props.history.push('/signin');
    }

    const { history, userInfo } = props;
    const userId = getPath(userInfo, 'id', null);
    if (!userId) {
      return false;
    }

    // facebook auth transition
    const user = authManager.getCurrentUser();
    const hasFacebookAuth = await isUserSessionHasFacebookAuth(user);
    if (hasFacebookAuth) {
      const transitionUser = { ...userInfo };
      return history.replace('/signin/transition', { transitionUser });
    }

    // get all soundcasts werged with subscriptions from back end
    try {
      const [soundcastsData, bundlesData] = await Axios.all([
        Axios.get(`/api/v2/library/users/${userId}/individuals`),
        Axios.get(`/api/v2/library/users/${userId}/bundles`),
      ]);
      const { data: soundcasts = [] } = soundcastsData;
      const { data: bundles = [] } = bundlesData;
      const userSoundcasts = [...bundles, ...soundcasts];

      this.setState({
        loading: false,
        userSoundcasts,
      });

      await this.loadBundlesSoundcasts(bundles);
    } catch {}
  }

  async loadBundlesSoundcasts(bundles) {
    const requests = bundles.map(boundleItem => {
      return new Promise(async resolve => {
        try {
          return resolve(
            Axios.get(`/api/v2/bundles/${boundleItem.soundcastId}/soundcasts`, {
              boundleItem,
            })
          );
        } catch (error) {
          console.log(`loadBundlesSoundcasts ${boundleItem.soundcastId} ERROR: `, error.message);
          return resolve(null);
        }
      });
    });
    const responses = await Promise.all(requests);

    const { userBundles } = this.state;

    responses.forEach(response => {
      if (isEmpty(response)) {
        return;
      }

      const { data = [], config = {} } = response;
      const { boundleItem = {} } = config;
      const {
        soundcastId: bundleId = '',
        subscribed = false,
        subscription_ended,
        current_period_end,
        date_subscribed,
        subscribedSoundcastsIncluded,
      } = boundleItem;

      if (isEmpty(bundleId)) {
        return;
      }

      userBundles[bundleId] = data
        .filter(item => subscribedSoundcastsIncluded.includes(item.soundcastId))
        .map(boundleItem => {
          return {
            ...boundleItem,
            subscribed,
            subscription_ended,
            current_period_end,
            date_subscribed,
          };
        });
    });

    this.setState({
      userBundles,
    });
  }

  isSoundcastBundle(soundcast) {
    const bundle = getPath(soundcast, 'bundle', false);
    const bundleId = getPath(soundcast, 'bundleId', '');
    return bundle && isEmpty(bundleId);
  }

  unsubscribeSoundcast(soundcast, force = false) {
    return new Promise((resolve, reject) => {
      const { soundcastId, subscribed = false, publisherId } = soundcast;

      if (!subscribed) {
        return false;
      }

      const { id: userId } = this.props.userInfo;

      const body = {
        source: 'webapp',
        userId,
        soundcastId,
        publisherId,
      };

      // if it was force unsubscribe without user consent
      if (force) {
        body.force = force;
      }

      Axios.post('/api/unsubscribe', body)
        .then(resolve)
        .catch(error => {
          console.error(error.message);
          reject();
        });
    });
  }

  handleSubscription(soundcast) {
    return async () => {
      const { userSoundcasts } = this.state;
      const { soundcastId } = soundcast;

      // get the current sub status of listener to the soundcast
      const {
        subscribed = false,
        current_period_end: accessDate = 0,
        bundleId = '',
        subscription_ended: subscriptionEnded = false,
      } = soundcast; // because the soundcast is merged with the subscription on back end

      const endDate = moment.unix(Number(accessDate)).format('YYYY-MM-DD');

      // if subscription ended do not continue to unsubscribe
      // technically listener already unsubscribe but the access still alive
      if (subscribed && subscriptionEnded) {
        return alert(
          `You have already unsubscribed to this audio program but you still have access till ${endDate}.`
        );
      }

      // if bundleId exist, its part of a bundle soundcast. We should get the bundle soundcast
      // to unsubscribe to every soundcasts
      const isBundleTarget = !isEmpty(bundleId);
      if (isBundleTarget) {
        const userBundles = userSoundcasts.filter(result => this.isSoundcastBundle(result));
        const bundleSoundcast = userBundles.filter(bundle => isEqual(bundle.soundcastId, bundleId));
        soundcast = head(bundleSoundcast);
      }

      const confirmMessage = isBundleTarget
        ? `This audio program is part of a bundle "${soundcast.title}". You'll unsubscribe to this and to every audio program of the bundle. Do you want to continue?`
        : 'Are you sure you want to unsubscribe from this audio program?';

      const confirmUnsubscribe = confirm(confirmMessage);
      if (confirmUnsubscribe) {
        this.unsubscribeSoundcast(soundcast).then(async response => {
          const { data } = response;
          const { subscription = false, userSubscription } = data;
          const { subscribed = false } = userSubscription;

          // update the soundcast that corresponds to the result above
          const nUserSoundcasts = userSoundcasts.map(userSoundcast => {
            if (isEqual(soundcastId, userSoundcast.soundcastId)) {
              userSoundcast.subscribed = subscribed;
            }

            return userSoundcast;
          });

          this.setState({ userSoundcasts: nUserSoundcasts }, () => {
            if (subscription) {
              alert(
                `You have been successfully unsubscribed. You still have access till ${endDate}.`
              );
            } else {
              alert('You have been successfully unsubscribed.');
            }
          });
        });
      }
    };
  }

  handleSoundcastAccess(soundcast) {
    return () => {
      const url = getLandingPageUrl(soundcast.soundcastId, true);
      window.location.href = url;
    };
  }

  renderAccessStatus(soundcast) {
    const { current_period_end = 0 } = soundcast || {};
    const dateThen = moment.unix(current_period_end);
    const accessDate = dateThen.format('MM/DD/YYYY');
    let status = `Access expired on ${accessDate}`;

    if (isValidSubscription(soundcast)) {
      // detect lifetime access if more than 50years
      const dateNow = moment();
      const duration = moment.duration(dateThen.diff(dateNow));
      const years = duration.asYears();
      let message = 'Current access is valid';
      if (years < 50) {
        message = `${message} till ${accessDate}`;
      }

      status = message;
    }

    return status;
  }

  renderSoundcastClickableLink(soundcast, isBundleItem = false) {
    const { title = '', imageUrl = '', bundle = false } = soundcast || {};
    let content = (
      <>
        <img src={polishImageUrl(imageUrl)} alt="Soundcast image" />
        <SoundcastDetails justifyContent="center" title={title}>
          <label className="text-extra-large">{title}</label>
          <label className="no-margin">{this.renderAccessStatus(soundcast)}</label>
        </SoundcastDetails>
      </>
    );

    if (!bundle && isValidSubscription(soundcast)) {
      const { soundcastId = '', subscribed = false } = soundcast || {};
      const targetUrl = `${subscribed ? '/mysoundcasts' : 'soundcasts'}/${soundcastId}`;
      content = <FlexiLink to={targetUrl}>{content}</FlexiLink>;
    }

    return (
      <SoundcastInfo
        className="col-lg-10 col-md-7 col-sm-7 col-xs-12"
        alignItems="center"
        isBundle={bundle}
        bundleItem={isBundleItem}>
        {content}
      </SoundcastInfo>
    );
  }

  renderBundleSoundcasts(soundcast) {
    const { userBundles } = this.state;
    if (soundcast.soundcastId in userBundles) {
      const soundcasts = userBundles[soundcast.soundcastId];

      return this.renderUserSoundcasts(soundcasts, true);
    }
    return (
      <LoadingWrapper height="10">
        <Loading text="Loading soundcasts, please wait" />
      </LoadingWrapper>
    );
  }

  renderUserSoundcasts(soundcasts, renderBundleItems = false) {
    return soundcasts.map((soundcast, i) => {
      const { soundcastId = '', bundle: isBundle = false, subscribed = false } = soundcast || {};
      if (!subscribed) {
        return null;
      }
      const isActive = isValidSubscription(soundcast);

      return (
        <React.Fragment key={`us${soundcastId}-${i}`}>
          <FlexiRow className="row" alignItems="center">
            {this.renderSoundcastClickableLink(soundcast, renderBundleItems)}
            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center">
              {isActive  && <ActiveStatus />}
              {!isActive && <InactiveStatus />}
            </div>
            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center">
              {renderBundleItems && (
                <BundleItemButton
                  disabled
                  className="btn btn-medium"
                  primaryColor={Colors.mainWhite}
                  textColor={Colors.mainOrange}
                  borderColor={Colors.mainOrange}>
                  Bundle Item
                </BundleItemButton>
              )}
              {!renderBundleItems && (
                <>
                  {(isActive && (
                    <>
                      <div
                        id="multi-action-dropdown"
                        className="btn dropdown-toggle"
                        data-toggle="dropdown">
                        <i className="fas fa-ellipsis-v text-extra-large no-margin" />
                      </div>
                      <ul className="dropdown-menu">
                        <li>
                          <a
                            datatoggle="tooltip"
                            dataplacement="top"
                            title="Unsubscribe"
                            onClick={this.handleSubscription(soundcast)}>
                            Unsubscribe
                          </a>
                        </li>
                      </ul>
                    </>
                  )) || (
                    <AccessButton
                      className="btn btn-medium"
                      onClick={this.handleSoundcastAccess(soundcast)}
                      primaryColor={Colors.mainWhite}
                      textColor={Colors.mainOrange}
                      borderColor={Colors.mainOrange}
                      hoverOpacity={0.8}>
                      Get Access
                    </AccessButton>
                  )}
                </>
              )}
            </div>
          </FlexiRow>
          {isBundle && this.renderBundleSoundcasts(soundcast)}
        </React.Fragment>
      );
    });
  }

  render() {
    const isLoggedIn = this.props.isLoggedIn;
    const { userSoundcasts = [], loading = true } = this.state;

    if (isLoggedIn === false) {
      return (
        <FullContentWrapper>
          <SoundwiseHeader />
          <FullContentSection
            className="padding-110px-tb bg-white builder-bg xs-padding-60px-tb"
            id="feature-section14">
            <div className="container">
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12 text-center">
                  <h2 className="section-title-large sm-section-title-medium xs-section-title-large text-dark-gray font-weight-600 alt-font margin-three-bottom xs-margin-fifteen-bottom tz-text">
                    PLEASE LOG IN FIRST
                  </h2>
                </div>
              </div>
            </div>
          </FullContentSection>
          <Footer />
        </FullContentWrapper>
      );
    }

    return (
      <FullContentWrapper>
        <SoundwiseHeader />
        {loading && (
          <LoadingWrapper height="80">
            <Loading text="Loading soundcasts, please wait" />
          </LoadingWrapper>
        )}
        {!loading && (
          <FullContentSection
            className="padding-90px-tb bg-white builder-bg xs-padding-60px-tb"
            id="feature-section14">
            <div className="container">
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12 text-center">
                  <h2 className="section-title-large sm-section-title-medium xs-section-title-large text-dark-gray font-weight-600 alt-font margin-three-bottom xs-margin-fifteen-bottom tz-text">
                    {(!isEmpty(userSoundcasts) && 'MY LIBRARY') ||
                      `YOU HAVEN'T SUBSCRIBED TO ANY AUDIO PROGRAMS YET`}
                  </h2>
                </div>
              </div>
              {this.renderUserSoundcasts(userSoundcasts)}
            </div>
          </FullContentSection>
        )}
        <Footer showPricing={false} />
      </FullContentWrapper>
    );
  }
}

const FlexiLink = styled(Link)`
  width: 100%;
  display: flex;
  align-items: center;

  label {
    cursor: pointer;
  }
`;

const SoundcastInfo = styled(FlexiRow)`
  height: 100px;
  background-color: #fff;

  ${props =>
    props.isBundle
      ? `
    border-width: 2px;
    border-color: #ffebe0;
    border-style: solid;
    border-radius: 8px;
    `
      : ''
  };

  ${props =>
    props.bundleItem
      ? `
    border-left-width: 2px;
    border-left-color: #ffebe0;
    border-left-style: solid;
    margin-left: 15px;
    margin-right: -15px;
  `
      : ''};

  img {
    width: 75px;
    height: 75px;
    box-shadow: rgba(0, 0, 0, 0.5) 0px 1px 2px;
    margin-right: 30px;
  }
`;

const SoundcastDetails = styled(FlexiRow)`
  flex-direction: column;
`;

const UnsubscribeButton = styled(BaseButton)`
  border-radius: 20px;
  width: 130px;
`;

const BundleItemButton = styled(UnsubscribeButton)`
  border-radius: 5px;
`;

const AccessButton = styled(UnsubscribeButton)``;

const Status = styled.span`
  color: #fff;
  font-size: 1rem;
  border-radius: 4px;
  width: 60px;
  display: inline-block;
  text-transform: uppercase;
  margin-right: 5px;
`;

const InactiveStatus = styled(Status)`
  background-color: ${Colors.fontGrey};
  &:before {
    content: 'Inactive';
  }
`;

const ActiveStatus = styled(Status)`
  background-color: ${Colors.mainOrange};
  &:before {
    content: 'Active';
  }
`;

const mapStateToProps = state => {
  const { userInfo, isLoggedIn } = state.user;
  return { userInfo, isLoggedIn };
};

export default connect(mapStateToProps, null)(MySoundcasts);
